import { useEffect, useState } from "react";
import { formatCurrency } from "../../util";

const BudgetTableContainer = ({ label, content }) => {
  const [totalArr, setTotalArr] = useState(
    content.map((item) => item.amount * item.quantity)
  );

  useEffect(() => {
    setTotalArr(content.map((item) => item.amount * item.quantity));
  }, []);

  return (
    <>
      {content.length > 0 && (
        <div className="mt-6 w-full ">
          <h5 className="mb-2 font-medium  text-text-1/90 ">{label}</h5>
          <div className="w-full ">
            <table className="w-full">
              <thead>
                <tr className="bg-bkg text-nowrap">
                  <td className="p-2 py-2 bg-gray-600 text-text-gen px-2">
                    No
                  </td>
                  <td className="p-2 py-2 bg-gray-600 text-text-gen ">
                    Description
                  </td>
                  <td className="p-2 py-2 bg-gray-600 text-text-gen ">
                    Category
                  </td>
                  <td className="p-2 py-2 bg-gray-600 text-text-gen text-center">
                    Qty
                  </td>
                  <td className="p-2 py-2 bg-gray-600 text-text-gen text-center">
                    Unit Price
                  </td>
                  <td className="p-2 py-2 bg-gray-600 text-text-gen  text-right">
                    Total
                  </td>
                </tr>
              </thead>
              <tbody>
                {content.map((item, index) => (
                  <tr key={index}>
                    <td className="p-2 px-2">{++index}</td>
                    <td className="p-2">{item.name}</td>
                    <td className="p-2">{item.sub_category || "N/A"}</td>
                    <td className="p-2 text-center">{item.quantity}</td>
                    <td className="p-2 text-center">{item.amount}</td>
                    <td className="p-2 text-center">
                      {formatCurrency(item.quantity * item.amount)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td className="font-bold text-base px-2 p-2" colSpan={5}>
                    Total
                  </td>
                  <td className="font-bold text-base text-right p-2">
                    {formatCurrency(
                      totalArr.reduce((acc, item) => item + acc, 0)
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default BudgetTableContainer;
